import { render, staticRenderFns } from "./ProjTpeTree.vue?vue&type=template&id=e8dd9b6e&scoped=true&"
import script from "./ProjTpeTree.vue?vue&type=script&lang=js&"
export * from "./ProjTpeTree.vue?vue&type=script&lang=js&"
import style0 from "./ProjTpeTree.vue?vue&type=style&index=0&id=e8dd9b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dd9b6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCard,VMenu,VTextField,VTreeview})
